<template>
    <rkm-area
        class="pb-1"
        title="Outros procedimentos"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col
                class="mb-2"
                cols="12"
            >
                <rkm-form-checkbox
                    v-for="(outroProcedimento, index) in data.form.preAtendimento.outrosProcedimentos"
                    :key="index"
                    :value="outroProcedimento.id"
                    @change.native="handleOutroProcedimentoChange"
                    inline
                >
                    {{outroProcedimento.nome}}
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    methods: {
        handleOutroProcedimentoChange(event) {
            const outroProcedimento = this.data.form.preAtendimento.outrosProcedimentos.find(outroProcedimento => outroProcedimento.id === parseInt(event.target.value))

            if (event.target.checked) {
                this.data.model.preAtendimento.outrosProcedimentos.push(parseInt(event.target.value))
            } else {
                this.data.model.preAtendimento.outrosProcedimentos.splice(this.data.model.preAtendimento.outrosProcedimentos.indexOf(parseInt(event.target.value)) , 1)
            }

            if (outroProcedimento.codigo) {
                this.$emit('outroProcedimentoChange', {
                    checked: event.target.checked,
                    codigo: outroProcedimento.codigo,
                })
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>